<div
    class="truncate"
    #textEl
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="onClick($event)"
    tabindex="0"
>
  <ng-content></ng-content>
</div>

<ng-template #tooltipTemplate>
  <div
    class="tooltip-content text-sm bg-ui-interactive text-white py-1.5 px-2 border-transparent rounded-md opacity-95"
    role="tooltip"
  >
    <span [innerHTML]="text"></span>
  </div>
</ng-template>
